/* unplugin-vue-components disabled */import { render } from "./Historicalrecords.vue?vue&type=template&id=76cc9812&scoped=true"
import script from "./Historicalrecords.vue?vue&type=script&lang=js"
export * from "./Historicalrecords.vue?vue&type=script&lang=js"

import "./Historicalrecords.vue?vue&type=style&index=0&id=76cc9812&lang=less&scoped=true"
import "./Historicalrecords.vue?vue&type=style&index=1&id=76cc9812&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cc9812"]])

export default __exports__